import { SelectOption } from '@components/shared/FormField'

export enum LeadershipPlusLevelAchievedValue { BELOW_F_PLATINUM, FOUNDERS_PLATINUM_TO_FOUNDERS_EMERALD, DIAMOND_AND_ABOVE }
export enum LeadershipPlusFqGrowthValue { DROP, MAINTAIN, FQS_1_TO_5, FQS_6_PLUS }

export function leadershiPlusIncentiveLevelAchievedOptions(): SelectOption<LeadershipPlusLevelAchievedValue>[] {

  const levelAchievedOptions: SelectOption<LeadershipPlusLevelAchievedValue>[] = [
    { label: 'BELOW_FOUNDERS_PLATINUM', value: LeadershipPlusLevelAchievedValue.BELOW_F_PLATINUM },
    { label: 'FOUNDERS_PLATINUM_TO_FOUNDERS_EMERALD', value: LeadershipPlusLevelAchievedValue.FOUNDERS_PLATINUM_TO_FOUNDERS_EMERALD },
    { label: 'DIAMOND_AND_ABOVE', value: LeadershipPlusLevelAchievedValue.DIAMOND_AND_ABOVE }
  ]

  return levelAchievedOptions
}

export function leadershiPlusIncentiveFqGrowthOptions(): SelectOption<LeadershipPlusFqGrowthValue>[] {
  const fqGrowthOptions: SelectOption<LeadershipPlusFqGrowthValue>[] = [
    { label: 'DROP', value: LeadershipPlusFqGrowthValue.DROP },
    { label: 'MAINTAIN', value: LeadershipPlusFqGrowthValue.MAINTAIN },
    { label: 'FQS_1_TO_5', value: LeadershipPlusFqGrowthValue.FQS_1_TO_5 },
    { label: 'FQS_6_PLUS', value: LeadershipPlusFqGrowthValue.FQS_6_PLUS }
  ]

  return fqGrowthOptions
}
